export const databaseOptions = [
    {
        key: 0,
        text: "Statistics",
        value: "statistics"
    },

    {
        key: 3,
        text: "Pronunciation",
        value: "pronunciationAssignments"
    },
    {
        key: 6,
        text: "Dialog",
        value: "dialogAssignments"
    },
    {
        key: 4,
        text: "Translation Flash Cards",
        value: "translationFCAssignments"
    },
    {
        key: 5,
        text: "Dialog Flash Cards",
        value: "dialogFCAssignments"
    },

    {
        key: 7,
        text: "Translation Practice",
        value: "quizAssignments"
    }
];
